module.exports = __webpack_public_path__ + "static/media/WelcomePopup.07188a8b.png";